/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusefactors_Factualbody3Inputs */

const id_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami terutama menyajikan data faktual seperti judul game, tanggal rilis, dan pengembang, yang kurang dilindungi di bawah hak cipta.`)
};

const ms_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami terutamanya membentangkan data faktual seperti tajuk permainan, tarikh keluaran, dan pembangun, yang kurang dilindungi di bawah hak cipta.`)
};

const da_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi præsenterer primært faktuelle data som spiltitler, udgivelsesdatoer og udviklere, som er mindre beskyttet under ophavsret.`)
};

const de_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir präsentieren hauptsächlich sachliche Daten wie Spieltitel, Veröffentlichungsdaten und Entwickler, die urheberrechtlich weniger geschützt sind.`)
};

const en_us2_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We primarily present factual data like game titles, release dates, and developers, which is less protected under copyright.`)
};

const es_es2_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentamos principalmente datos factuales como títulos de juegos, fechas de lanzamiento y desarrolladores, que están menos protegidos por derechos de autor.`)
};

const es_mx2_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentamos principalmente datos factuales como títulos de juegos, fechas de lanzamiento y desarrolladores, que están menos protegidos por derechos de autor.`)
};

const fil_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangunahing naglalahad kami ng makatotohanang datos tulad ng mga pamagat ng laro, petsa ng release, at developer, na mas mababa ang proteksyon sa ilalim ng copyright.`)
};

const fr_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous présentons principalement des données factuelles comme les titres de jeux, les dates de sortie et les développeurs, qui sont moins protégées par le droit d'auteur.`)
};

const it_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentiamo principalmente dati fattuali come titoli di giochi, date di uscita e sviluppatori, che sono meno protetti dal diritto d'autore.`)
};

const hu_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elsősorban tényszerű adatokat mutatunk be, mint például játékcímeket, megjelenési dátumokat és fejlesztőket, amelyek kevésbé védettek a szerzői jog által.`)
};

const nl_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We presenteren voornamelijk feitelijke gegevens zoals gametitels, releasedata en ontwikkelaars, die minder beschermd zijn onder auteursrecht.`)
};

const no_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi presenterer hovedsakelig faktiske data som spilltitler, utgivelsesdatoer og utviklere, som er mindre beskyttet under opphavsrett.`)
};

const pl_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentujemy głównie dane faktyczne, takie jak tytuły gier, daty wydania i deweloperów, które są mniej chronione prawem autorskim.`)
};

const pt_br2_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apresentamos principalmente dados factuais, como títulos de jogos, datas de lançamento e desenvolvedores, que são menos protegidos por direitos autorais.`)
};

const pt_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apresentamos principalmente dados factuais como títulos de jogos, datas de lançamento e desenvolvedores, que são menos protegidos por direitos de autor.`)
};

const ro_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentăm în principal date faptice, cum ar fi titluri de jocuri, date de lansare și dezvoltatori, care sunt mai puțin protejate de drepturile de autor.`)
};

const fi_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esitämme pääasiassa faktatietoja, kuten pelien nimiä, julkaisupäiviä ja kehittäjiä, jotka ovat vähemmän suojattuja tekijänoikeudella.`)
};

const sv_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi presenterar främst faktadata som speltitlar, releasedatum och utvecklare, vilket är mindre skyddat av upphovsrätt.`)
};

const vi_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chúng tôi chủ yếu trình bày dữ liệu thực tế như tên game, ngày phát hành và nhà phát triển, những thông tin ít được bảo vệ hơn theo luật bản quyền.`)
};

const tr_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öncelikle oyun başlıkları, çıkış tarihleri ve geliştiriciler gibi telif hakkı kapsamında daha az korunan olgusal verileri sunuyoruz.`)
};

const cs_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentujeme především faktická data jako názvy her, data vydání a vývojáře, která jsou méně chráněna autorským zákonem.`)
};

const bg_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ние представяме предимно фактически данни като заглавия на игри, дати на издаване и разработчици, които са по-слабо защитени от авторско право.`)
};

const ru_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В основном мы представляем фактические данные, такие как названия игр, даты выхода и имена разработчиков, которые в меньшей степени защищены авторским правом.`)
};

const uk_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ми переважно надаємо фактичні дані, такі як назви ігор, дати виходу та розробників, які менше захищені авторським правом.`)
};

const ar_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقدم بشكل أساسي بيانات واقعية مثل عناوين الألعاب وتواريخ الإصدار والمطورين، وهي أقل حماية بموجب حقوق الطبع والنشر.`)
};

const hi_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम मुख्य रूप से तथ्यात्मक डेटा जैसे गेम शीर्षक, रिलीज़ तिथियाँ और डेवलपर प्रस्तुत करते हैं, जो कॉपीराइट के तहत कम संरक्षित हैं।`)
};

const th_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรานำเสนอข้อมูลข้อเท็จจริงเป็นหลัก เช่น ชื่อเกม วันที่วางจำหน่าย และผู้พัฒนา ซึ่งได้รับการคุ้มครองน้อยกว่าภายใต้ลิขสิทธิ์`)
};

const ja_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームタイトル、リリース日、開発者などの事実データを主に提示しており、これらは著作権による保護が弱いものです。`)
};

const zh_cn2_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们主要展示事实性数据，如游戏名称、发布日期和开发商，这些内容受版权保护程度较低。`)
};

const zh_hant1_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們主要展示事實性資料，如遊戲名稱、發布日期和開發商，這些內容受版權保護程度較低。`)
};

const ko_about_fairusefactors_factualbody3 = /** @type {(inputs: About_Fairusefactors_Factualbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 제목, 출시일, 개발자 등과 같은 사실적 데이터를 주로 제공하며, 이는 저작권 보호가 덜 적용됩니다.`)
};

/**
* | output |
* | --- |
* | "We primarily present factual data like game titles, release dates, and developers, which is less protected under copyright." |
*
* @param {About_Fairusefactors_Factualbody3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusefactors_factualbody3 = /** @type {((inputs?: About_Fairusefactors_Factualbody3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusefactors_Factualbody3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusefactors_factualbody3(inputs)
	if (locale === "ms") return ms_about_fairusefactors_factualbody3(inputs)
	if (locale === "da") return da_about_fairusefactors_factualbody3(inputs)
	if (locale === "de") return de_about_fairusefactors_factualbody3(inputs)
	if (locale === "en-US") return en_us2_about_fairusefactors_factualbody3(inputs)
	if (locale === "es-ES") return es_es2_about_fairusefactors_factualbody3(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusefactors_factualbody3(inputs)
	if (locale === "fil") return fil_about_fairusefactors_factualbody3(inputs)
	if (locale === "fr") return fr_about_fairusefactors_factualbody3(inputs)
	if (locale === "it") return it_about_fairusefactors_factualbody3(inputs)
	if (locale === "hu") return hu_about_fairusefactors_factualbody3(inputs)
	if (locale === "nl") return nl_about_fairusefactors_factualbody3(inputs)
	if (locale === "no") return no_about_fairusefactors_factualbody3(inputs)
	if (locale === "pl") return pl_about_fairusefactors_factualbody3(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusefactors_factualbody3(inputs)
	if (locale === "pt") return pt_about_fairusefactors_factualbody3(inputs)
	if (locale === "ro") return ro_about_fairusefactors_factualbody3(inputs)
	if (locale === "fi") return fi_about_fairusefactors_factualbody3(inputs)
	if (locale === "sv") return sv_about_fairusefactors_factualbody3(inputs)
	if (locale === "vi") return vi_about_fairusefactors_factualbody3(inputs)
	if (locale === "tr") return tr_about_fairusefactors_factualbody3(inputs)
	if (locale === "cs") return cs_about_fairusefactors_factualbody3(inputs)
	if (locale === "bg") return bg_about_fairusefactors_factualbody3(inputs)
	if (locale === "ru") return ru_about_fairusefactors_factualbody3(inputs)
	if (locale === "uk") return uk_about_fairusefactors_factualbody3(inputs)
	if (locale === "ar") return ar_about_fairusefactors_factualbody3(inputs)
	if (locale === "hi") return hi_about_fairusefactors_factualbody3(inputs)
	if (locale === "th") return th_about_fairusefactors_factualbody3(inputs)
	if (locale === "ja") return ja_about_fairusefactors_factualbody3(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusefactors_factualbody3(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusefactors_factualbody3(inputs)
	return ko_about_fairusefactors_factualbody3(inputs)
});
export { about_fairusefactors_factualbody3 as "about.fairUseFactors.factualBody" }